export enum CommunicationChannels {
  Email = 0,
  MsTeams = 1,
}
